import _ from 'lodash';
export const isArrayEqual = (arrayOne: any[], arrayTwo: any[]) => {
  return arrayOne.every((item1, index) => _.isEqual(item1, arrayTwo[index]));
};
